<template>
    <div class="row">
        <div class="col-2"><i v-if="back == 1" class="p-3 fa-solid fa-arrow-rotate-left fa-2x" id="back"
                @click="goBack()"></i> <span class="fw-bold text-danger" v-if="!online">Offline!</span>
            <i v-if="notifications == true" class="p-3 fa-solid fa-envelope fa-2x frontend-green"></i>
        </div>
        <div class="col-8 mb-2 mt-2"><img src="/img/logo_grey.png" class="mx-auto d-block" style="width: 50%;" id="logo"
                @click="reload">
        </div>
        <div class="col-1 p-3" id="topright">
            <span v-if="spinner == 1" class="spinner"></span>
        </div>
        <div class="col-1 p-3" id="topright">
            <svg v-if="signal == 1" @click="showInfo" class="pull-end show-ssid" id="signal-1" height="32" width="32"
                xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256">
                <rect width="256" height="256" fill="none" />
                <circle cx="128" cy="200" r="16" fill="#F00" />
            </svg>
            <svg v-if="signal == 2" @click="showInfo" class="pull-end show-ssid" id="signal-2" height="32" width="32"
                xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256">
                <rect width="256" height="256" fill="none" />
                <path d="M92.9,166.1a50.7,50.7,0,0,1,70.2,0" fill="none" stroke="#B80" stroke-linecap="round"
                    stroke-linejoin="round" stroke-width="24" />
                <circle cx="128" cy="200" r="16" fill="#B80" />
            </svg>
            <svg v-if="signal == 3" @click="showInfo" class="pull-end show-ssid" id="signal-3" height="32" width="32"
                xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256">
                <rect width="256" height="256" fill="none" />
                <path d="M92.9,166.1a50.7,50.7,0,0,1,70.2,0" fill="none" stroke="#0C0" stroke-linecap="round"
                    stroke-linejoin="round" stroke-width="24" />
                <path d="M59,132.1a98.8,98.8,0,0,1,138,0" fill="none" stroke="#0C0" stroke-linecap="round"
                    stroke-linejoin="round" stroke-width="24" />
                <circle cx="128" cy="200" r="16" fill="#0C0" />
            </svg>
            <svg v-if="signal == 4" @click="showInfo" class="pull-end show-ssid" id="signal-4" height="32" width="32"
                xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256">
                <rect width="256" height="256" fill="none" />
                <path d="M92.9,166.1a50.7,50.7,0,0,1,70.2,0" fill="none" stroke="#0C0" stroke-linecap="round"
                    stroke-linejoin="round" stroke-width="24" />
                <path d="M59,132.1a98.8,98.8,0,0,1,138,0" fill="none" stroke="#0C0" stroke-linecap="round"
                    stroke-linejoin="round" stroke-width="24" />
                <path d="M25.1,98.2a146.6,146.6,0,0,1,205.8,0" fill="none" stroke="#0C0" stroke-linecap="round"
                    stroke-linejoin="round" stroke-width="24" />
                <circle cx="128" cy="200" r="16" fill="#0C0" />
            </svg>
            <svg v-if="signal == 0" @click="showInfo" class="pull-end show-ssid" id="signal-0" height="32" width="32"
                xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256">
                <rect width="256" height="256" fill="none" />
                <path d="M92.9,166.1a50.7,50.7,0,0,1,70.2,0" fill="none" stroke="#F00" stroke-linecap="round"
                    stroke-linejoin="round" stroke-width="24" />
                <line x1="224" y1="56" x2="176" y2="104" fill="none" stroke="#F00" stroke-linecap="round"
                    stroke-linejoin="round" stroke-width="24" />
                <line x1="224" y1="104" x2="176" y2="56" fill="none" stroke="#F00" stroke-linecap="round"
                    stroke-linejoin="round" stroke-width="24" />
                <path d="M25.1,98.2A145.6,145.6,0,0,1,128,56l8,.2" fill="none" stroke="#F00" stroke-linecap="round"
                    stroke-linejoin="round" stroke-width="24" />
                <path d="M59,132.1A97.8,97.8,0,0,1,128,104c2.7,0,5.4.1,8,.3" fill="none" stroke="#F00"
                    stroke-linecap="round" stroke-linejoin="round" stroke-width="24" />
                <circle cx="128" cy="200" r="16" fill="#F00" />
            </svg>
            <svg v-if="!signal" @click="showInfo" fill="#ffffff" class="pull-end show-ssid" id="signal-none" width="32"
                height="32" viewBox="0 0 549.76 549.76" xml:space="preserve">
                <g>
                    <path
                        d="M332.622,454.776c0,31.58-25.582,57.162-57.161,57.162S218.3,486.356,218.3,454.776c0-31.578,25.582-57.16,57.161-57.16
                S332.622,423.198,332.622,454.776z M365.241,254.041c-17.992-7.589-36.658-12.852-55.814-15.667l97.125,97.063l32.007-32.008
                C417.384,282.254,392.72,265.607,365.241,254.041z M177.418,257.652c-25.398,11.934-48.226,28.212-67.81,48.531l70.38,68.055
                c20.441-21.176,46.573-34.578,75.031-38.984L177.418,257.652z M60.955,141.127C39.106,155.57,18.727,172.155,0,190.944
                l69.217,69.217c18.85-18.85,39.964-34.884,62.914-47.797L60.955,141.127z M426.319,107.1
                c-47.798-20.074-98.594-30.294-150.858-30.294c-38.127,0-75.398,5.447-111.323,16.157l83.109,83.109
                c9.303-0.918,18.728-1.346,28.213-1.346c77.418,0,150.308,29.988,205.326,84.456l68.973-69.523
                C514.019,154.285,472.525,126.5,426.319,107.1z M33.292,77.663l382.561,382.561l39.842-39.842L73.134,37.821L33.292,77.663z" />
                </g>
            </svg>
        </div>
    </div>

    <div v-if="waiting" id="stampdiv">
        <div class="row" style="height: 20vh;">
            <div v-if="message" class="alert alert-info">{{ message }}</div>
            <div class="col text-center" id="debug">
                {{ debugmessage }}<br>
                <!--                <button @click="addStamp(1, 2, device_id, 3)" :disabled="addDisabled">Add</button>
                <button @click="delStamp()">Remove</button><br>
                <div v-for="stamp in stamps">
                    {{ stamp }}
                </div> -->
            </div>
        </div>
        <div class="row display-2">
            <div class="col-12 text-center font-weight-bolder" id="timediv">{{ time }}</div>
        </div>
        <div class="row display-6">
            <div class="col-12 text-center font-weight-bolder" id="datediv">{{ date }}</div>
        </div>
        <div class="row" style="height: 20vh;"></div>
        <div class="row display-8">
            <div class="col-12 text-center frontend-green">System operational</div>
        </div>
        <div class="row p-2">
            <div class="col-12 text-center align-middle">

                <div id="clock"></div>

                <form action="/stamp" method="post" id="stamp">
                    <input type="hidden" id="rfid" name="badgenumber">
                    <input type="hidden" name="device_id" value="{{ $device->id }}">
                </form>

                <!--
                <div class="row m-2">
                    <div class="col text-center align-middle"><a href="{{ route('manual') }}" class="btn btn-primary">Use
                            PIN</a></div>
                </div>
                -->
            </div>
        </div>
    </div>

    <div v-if="offline" id="offline">
        <div class="row" style="height: 10vh;"></div>

        <div class="row display-8">
            <div class="col-12 text-center text-danger"><i class="fa-solid fa-times-circle bg-white"
                    style="border-radius: 50%; font-size: 50vh;"></i></div>
        </div>
        <div class="row" style="height: 5vh;"></div>
        <div class="row display-9">
            <div class="col-12 text-center">System offline</div>
        </div>
    </div>

    <div v-if="welcome" id="welcome">
        <div class="row" style="height: 40vh;">
        </div>
        <div class="row display-4">
            <div class="col-12 text-center font-weight-bolder" id="greetingdiv">{{ greetingMessage }}</div>
        </div>
        <div class="row display-4">
            <div class="col-12 text-center font-weight-bolder" id="namediv">{{ employeeName }}</div>
        </div>
        <div v-if="notifications == true" class="row display-4">
            <div class="col-12 text-center font-weight-bolder" id="notificationdiv"><i
                    class="p-3 fa-solid fa-envelope fa-2x frontend-green"></i> Sie haben neue Nachrichten!</div>
        </div>
    </div>

    <div v-if="chooseProject || chooseClient || chooseSubproject" id="projectsdiv" class="h-80">
        <div class="row" style="height: 5vh;"></div>
        <div class="h-100 align-items-center d-flex">
            <div class="w-100 align-items-center">
                <div id="projects">
                    <div v-if="chooseClient" class="m-auto d-flex" style="max-width: 90%;flex-flow: row wrap;">
                        <div v-for="(client, index) in clients" class="projectbox m-1 bg-box-blue fw-bolder"
                            @click="displaySecondLevel(client)" :key="client.id">
                            {{ client.name?.toUpperCase() }}
                            <i v-if="client.quantity > 0 && index < 3" class="fas fa-star"
                                style="position: absolute;left: 2px;top:2px;"></i>
                        </div>
                    </div>

                    <div v-if="chooseProject && clientId" class="m-auto d-flex"
                        style="max-width: 90%;flex-flow: row wrap;">
                        <div v-for="(project, index) in clientProjects" class="projectbox m-1 bg-box-blue fw-bolder"
                            @click.once="stampProject(project)" :key="project.id">
                            {{ project.name }}
                            <i v-if="project.quantity > 0 && index < 3" class="fas fa-star"
                                style="position: absolute;left: 2px;top:2px;"></i>
                        </div>
                    </div>

                    <div v-if="chooseSubproject && project" class="m-auto d-flex"
                        style="max-width: 90%;flex-flow: row wrap;">
                        <div v-for="(subproject, index) in project.subprojects"
                            class="projectbox m-1 bg-box-blue fw-bolder" @click.once="stampProject(project, subproject)"
                            :key="subproject.id">
                            {{ subproject.name }}
                        </div>
                    </div>
                </div>
                <div class="row" style="height: 5vh;"></div>
                <div class="row display-9">
                    <div class="col-12 text-center" id="choosediv">{{ chooseMessage }}</div>
                </div>
            </div>
        </div>
    </div>

    <div v-if="stamped" id="stamped">
        <div class="row" style="height: 10vh;"></div>

        <div class="row display-8">
            <div class="col-7 text-center frontend-green"><i class="fa-solid fa-circle-check bg-white"
                    style="border-radius: 50%; font-size: 50vh;"></i></div>
            <div class="col-5" style="display: flex;align-items: center;">
                <table>
                    <tbody>
                        <tr>
                            <td>Customer:</td>
                            <td id="clientcell">{{ clientName }}</td>
                        </tr>
                        <tr>
                            <td>Project:</td>
                            <td id="projectcell">{{ projectName }}</td>
                        </tr>
                        <tr>
                            <td>Time:</td>
                            <td id="timecell">{{ time }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

    <div v-if="error" id="error">
        <div class="row" style="height: 10vh;"></div>

        <div class="row display-8">
            <div class="col-12 text-center text-danger"><i class="fa-solid fa-times-circle bg-white fa-10x"
                    style="border-radius: 50%;"></i></div>
        </div>
        <div class="row" style="height: 5vh;"></div>
        <div class="row display-6">
            <div class="col-12 text-center text-danger" id="errormessage">{{ message }}</div>
        </div>
    </div>
    <div v-if="info" id="info">
        <div class="row" style="height: 10vh;"></div>

        <div class="row display-8">
            <div class="col-12 text-center text-secondary"><i class="fa-solid fa-circle-info bg-white fa-10x"
                    style="border-radius: 50%;"></i></div>
        </div>
        <div class="row" style="height: 5vh;"></div>
        <div class="row display-6">
            <div class="col-12 text-center text-secondary" id="infomessage">{{ message }}</div>
        </div>
    </div>
</template>

<script>
import { getTransitionRawChildren, ref, watch } from "vue";

export default {
    name: "Clock",
    props: {
        device_id: Number,
        entrance: Boolean,
    },
    data() {
        return {
            badgenumbers: null,
            projects: null,
            clients: null,
            signal: null,
            back: 0,
            error: 0,
            info: false,
            message: null,
            waiting: true,
            spinner: false,
            offline: false,
            welcome: false,
            chooseMessage: null,

            chooseClient: false,
            client: null,
            clientId: null,
            clientName: null,

            chooseProject: false,
            project: null,
            projectName: null,

            chooseSubproject: false,
            subproject: null,

            stamped: false,
            employeeName: null,
            notifications: false,
            time: null,
            date: null,

            db: null,
            stamps: null,
            ready: false,
            addDisabled: false,

            lastWifi: {
                ssid: "n/a",
                hostname: "n/a"
            },
            online: true,
            debugmessage: null,
            backtimeout: 10,

            employee_id: null,
            greetingMessage: 'Welcome',

            // Werden die Stamps gerade zum Server geschickt?
            playBack: false,
            postingStamp: false

        }
    },
    computed: {
        clientProjects() {
            return this.projects.filter((item) => item.client_id == this.clientId);
        }
    },
    async created() {
        this.setTime();
        setInterval(this.setTime, 10000);
        this.fetchEmployeeBadgenumbers();
        setInterval(this.fetchEmployeeBadgenumbers, 1000 * 60 * 10); // Fetch badgenumbers every 10 Minutes
        this.fetchProjects();
        setInterval(this.fetchProjects, 1000 * 60 * 10); // Fetch projects every 10 Minutes
        this.pingServer(true);
        setInterval(this.pingServer, 10000);
        this.displayWifi();
        setInterval(this.displayWifi, 10000);


        this.db = await this.getDb();
        this.stamps = await this.getStampsFromDb();
        this.ready = true;
    },
    mounted() {
        document.addEventListener("keydown", this.onKeydown);
    },
    methods: {
        async getDb() {
            return new Promise((resolve, reject) => {

                let request = window.indexedDB.open('halisclock', 1);

                request.onerror = e => {
                    console.log('Error opening db', e);
                    reject('Error');
                };

                request.onsuccess = e => {
                    resolve(e.target.result);
                };

                request.onupgradeneeded = e => {
                    console.log('onupgradeneeded');
                    let db = e.target.result;
                    let objectStore = db.createObjectStore("stamps", { autoIncrement: true, keyPath: 'id' });
                };
            });
        },

        async getStampsFromDb() {
            return new Promise((resolve, reject) => {

                let trans = this.db.transaction(['stamps'], 'readonly');
                trans.oncomplete = e => {
                    resolve(stamps);
                };

                let store = trans.objectStore('stamps');
                let stamps = [];

                store.openCursor().onsuccess = e => {
                    let cursor = e.target.result;
                    if (cursor) {
                        stamps.push(cursor.value)
                        cursor.continue();
                    }
                };

            });
        },

        async addStamp(employee_id, project_id, device_id, subproject_id) {
            console.log("EmployeeId addStamp", employee_id);
            this.addDisabled = true;

            let stamp = {
                employee_id: employee_id,
                project_id: project_id,
                subproject_id: subproject_id,
                device_id: device_id,
                stamped_at: new Date()
            };

            console.log('about to add ' + JSON.stringify(stamp));
            await this.addStampToDb(stamp);
            this.stamps = await this.getStampsFromDb();
            this.addDisabled = false;
        },

        async addStampToDb(stamp) {
            return new Promise((resolve, reject) => {

                let trans = this.db.transaction(['stamps'], 'readwrite');
                trans.oncomplete = e => {
                    resolve();
                };

                let store = trans.objectStore('stamps');
                store.add(stamp);

            });
        },

        async deleteStamp(id) {
            await this.deleteStampFromDb(id);
            this.stamps = await this.getStampsFromDb();
        },

        async deleteStampFromDb(id) {
            return new Promise((resolve, reject) => {
                let trans = this.db.transaction(['stamps'], 'readwrite');
                trans.oncomplete = e => {
                    resolve();
                };

                let store = trans.objectStore('stamps');
                store.delete(id);
            });
        },

        async delStamp() {
            const stamp = this.stamps[0];
            await this.deleteStamp(stamp.id);
        },

        setTime() {
            var d = new Date();

            let ye = new Intl.DateTimeFormat('de', { year: 'numeric' }).format(d);
            let mo = new Intl.DateTimeFormat('de', { month: 'long' }).format(d);
            let da = new Intl.DateTimeFormat('de', { day: '2-digit' }).format(d);
            let wd = new Intl.DateTimeFormat('de', { weekday: 'long' }).format(d);
            this.date = `${wd}, ${da} ${mo} ${ye}`;

            let time = new Intl.DateTimeFormat('de', {
                hour: '2-digit',
                minute: '2-digit'
            }).format(d);

            this.time = time;
        },

        onKeydown(event) {
            if (this.norfid) {
                return;
            }

            if (this.end) {
                $('#rfid').val('');
                this.end = false;
            }

            if (!this.end && event.key !== 'Enter') {
                $('#rfid').val($('#rfid').val() + event.key);
            }

            if (event.key === 'Enter') {
                var rfid = parseInt($('#rfid').val());
                this.end = true;
                this.checkPIN();
            }
        },

        displayIndex() {
            clearTimeout(this.backtimeout);
            this.message = null;
            this.spinner = false;
            this.back = false;
            this.info = false;
            this.error = false;
            this.welcome = false;
            this.stamped = false;
            this.chooseClient = false;
            this.chooseProject = false;
            this.chooseSubproject = false;
            this.project = null;
            this.chooseSubproject = false;
            this.offline = false;
            this.waiting = true;
            this.notifications = false;
        },

        displayProjects() {
            this.spinner = false;
            this.back = false;
            this.error = false;
            this.welcome = false;
            this.stamped = false;
            this.chooseClient = true;
            this.project = null;
            this.offline = false;
            this.waiting = false;
            this.displayFirstLevel();
        },

        displayError(message) {
            console.log("displayError");
            this.message = message;
            this.error = true;
            this.spinner = false;
            this.back = false;
            this.welcome = false;
            this.stamped = false;
            this.chooseClient = false;
            this.chooseProject = false;
            this.chooseSubproject = false;
            this.project = null;
            this.offline = false;
            this.waiting = false;
            setTimeout(this.displayIndex, 2000);
        },

        displayInfo(message) {
            console.log("displayError");
            this.message = message;
            this.info = true;
            this.spinner = false;
            this.back = false;
            this.welcome = false;
            this.stamped = false;
            this.chooseClient = false;
            this.chooseProject = false;
            this.chooseSubproject = false;
            this.project = null;
            this.offline = false;
            this.waiting = false;
            setTimeout(this.displayIndex, 2000);
        },

        goBack() {
            if (this.chooseProject) {
                this.displayFirstLevel();
            }

            if (this.chooseSubproject) {
                this.displaySecondLevel(this.client);
            }
        },

        checkPIN() {
            const scannedNumber = parseInt($('#rfid').val());
            $('#rfid').val('');

            console.log('Check ' + scannedNumber);
            const badgeEmployee = this.badgenumbers.find((badge) => {
                return badge.badgenumber == scannedNumber
            });

            if (badgeEmployee) {
                this.employeeName = badgeEmployee.forename + " " + badgeEmployee.lastname;
                console.log('Found ' + this.employeeName);
                this.getEmployeeStatus(badgeEmployee.id);
                this.waiting = false;
                this.employee_id = badgeEmployee.id;
            } else {
                this.employee_id = null;
                this.displayError('Unknown card / token : ' + scannedNumber);
                console.log('Can not find ' + scannedNumber);
            }
        },

        getEmployeeStatus(employeeId) {
            console.log('Get Status for ' + employeeId);
            axios
                .get("/api/employees/" + employeeId + "/workstate", {
                    params: {
                        device_id: this.device_id
                    }
                })
                .then((resp) => {
                    console.log(resp.data);

                    this.notifications = resp.data.notifications > 0;

                    if (resp.data.working) {
                        this.greetingMessage = "Good bye";
                        this.welcome = true;
                        console.log("End project");
                        this.stampProject(null);
                        //trigger goodbye

                    } else {
                        // View Projects
                        this.greetingMessage = "Welcome";
                        this.welcome = true;
                        var timeout = 1000;
                        if (this.notifications) {
                            timeout += 1000;
                        }
                        if (!this.entrance) {
                            console.log("View projects");
                            setTimeout(this.displayProjects, timeout);
                        } else {
                            console.log("Entrance, stamp default");
                            setTimeout(this.stampDefault, timeout);
                        }
                    }
                })
                .catch((error) => {
                    if (error.code == "ERR_NETWORK") {
                        // Get State from DB?
                        const stamps = this.stamps.filter((item) => item.employee_id == employeeId);
                        console.log("Stamps 507", stamps);
                        console.log(stamps[stamps.length - 1]);
                        if (stamps.length > 0 && stamps[stamps.length - 1].project_id != null) {
                            console.log("Local stamps", stamps);
                            this.greetingMessage = "Good bye";
                            console.log("OFFLINE End project");
                            this.stampProject(null);

                        } else {
                            console.log("OFFLINE: View projects");
                            this.greetingMessage = "Welcome";
                            setTimeout(this.displayProjects, 1000);
                        }
                        this.welcome = true;

                    }
                    console.log("Error", error);
                    console.log("Error", error.message);
                });
        },

        displayFirstLevel() {
            var timeout = 3;
            this.spinner = false;
            this.welcome = false;
            this.chooseClient = true;
            this.chooseProject = false;


            timeout += this.clients.length * 2;

            this.chooseMessage = 'Please choose a customer...';
            clearTimeout(this.backtimeout);
            const that = this;
            this.backtimeout = setTimeout(function () {
                // Anonymous function weil eine funktion mit Klammern direkt aufgerufen wird.
                that.displayError('Timeout');
            }, timeout * 1000);
            this.back = 0;
        },

        displaySecondLevel(client) {
            this.clientId = client.id;
            this.clientName = client.name;
            this.client = client;

            this.chooseClient = false;
            this.chooseProject = true;
            this.chooseSubproject = false;
            this.chooseMessage = 'Please choose a project...';
            this.back = 1;

            clearTimeout(this.backtimeout);
            var timeout = 3;
            timeout += this.clientProjects.length * 2;

            const that = this;
            this.backtimeout = setTimeout(function () {
                // Anonymous function weil eine funktion mit Klammern direkt aufgerufen wird.
                that.displayError('Timeout');
            }, timeout * 1000);
        },

        displayThirdLevel(project) {
            this.project = project;
            this.chooseMessage = 'Please choose a subproject...';
            this.back = 1;
            this.chooseProject = false;
            this.chooseSubproject = true;

            clearTimeout(this.backtimeout);
            var timeout = 3;
            timeout += this.project.subprojects.length * 2;

            const that = this;
            this.backtimeout = setTimeout(function () {
                // Anonymous function weil eine funktion mit Klammern direkt aufgerufen wird.
                that.displayError('Timeout');
            }, timeout * 1000);
        },

        fetchProjects() {
            console.log("fetchProjects");
            axios
                .get("/api/stamping", {
                    params: {
                        device_id: this.device_id,
                        cachemode: 'cacheme'
                    }
                })
                .then((resp) => {
                    console.log("Projects", resp.data);
                    this.projects = resp.data.projects.filter((project) => project.archived == 0);
                    this.clients = resp.data.clients;
                })
                .catch((error) => {
                    console.log(error);
                });

        },

        fetchEmployeeBadgenumbers() {
            console.log("fetchBadgenumbers");
            axios
                .get("/api/badgenumbers", {
                    params: {
                        cachemode: 'cacheme'
                    }
                })
                .then((resp) => {
                    this.badgenumbers = resp.data;
                })
                .catch((error) => {
                    console.log(error);
                });

        },

        pingServer(initial = false) {
            const code = this.random(20);

            var ssid, quality, hostname;
            if (this.lastWifi) {
                ssid = this.lastWifi.ssid;
                quality = this.lastWifi.quality;
                hostname = this.lastWifi.hostname;
            }

            axios
                .get("/ping", {
                    params: {
                        device_id: this.device_id,
                        hash: code,
                        'ssid': ssid,
                        'quality': quality,
                        'hostname': hostname,
                        'initial': initial
                    }
                })
                .then((resp) => {
                    if (resp.data == 'restart') {
                        this.reload();
                        return;
                    }

                    if (resp.data == code && this.online == false) {
                        console.log('online!');
                        this.online = true;
                        this.replayStamps();
                    }
                })
                .catch((error) => {
                    console.log("Ping error: ", error);
                    if (this.online) {
                        console.log("offline");
                        this.online = false;
                    }
                });
        },
        random(length = 8) {
            // Declare all characters
            let chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

            // Pick characers randomly
            let str = '';
            for (let i = 0; i < length; i++) {
                str += chars.charAt(Math.floor(Math.random() * chars.length));
            }

            return str;

        },
        reload() {
            location.reload();
        },

        displayWifi() {
            const that = this;
            axios.get('http://localhost:80/wifi.json').then((resp) => {
                const data = resp.data;
                // console.log(data);
                // console.log("success", data.quality);
                that.lastWifi = data;

                var signal = data.quality?.split('/');

                var strength = null;
                if (signal) {
                    strength = parseInt(signal[0]) / parseInt(signal[1]);
                }

                // console.log("strength", strength);

                if (strength > 0.75) {
                    that.signal = 4;
                } else if (strength > 0.5) {
                    that.signal = 3;
                } else if (strength > 0.25) {
                    that.signal = 2;
                } else if (strength > 0.0) {
                    that.signal = 1;
                } else {
                    that.signal = 0;
                }
            }).catch((error) => {
                that.signal = null;
                if (error.code != "ERR_NETWORK") {
                    console.log("Error: ", error);
                }
            });
        },
        showInfo() {
            this.debugmessage = "DeviceID: " + this.device_id + " SSID: " + this.lastWifi?.ssid + "\r\nHostname: " + this.lastWifi.hostname;
        },

        async replayStamps() {
            if (this.playBack) {
                return;
            }
            this.playBack = true;

            for (let stamp of this.stamps) {
                console.log("Playback: ", stamp);
                await this.postStamp(stamp);
            }

            this.playBack = false;

        },

        async postStamp(stamp) {
            try {
                await axios
                    .post("/api/projectstamp", stamp)
                    .then((resp) => {
                        console.log('Local delete', stamp)
                        this.deleteStamp(stamp.id);
                    });
            } catch (error) {
                console.log("Error: ", error);
            }
        },
        stampDefault() {
            console.log('Stamp project', this.projects[0]);
            this.stampProject(this.projects[0]);
        },
        stampProject(project, subproject = null) {
            this.welcome = false;
            this.waiting = false;

            clearTimeout(this.backtimeout);
            this.projectName = project?.name;

            if (subproject == null && project?.subprojects?.length > 0) {
                this.displayThirdLevel(project);
                return;
            }

            this.chooseClient = false;
            this.chooseProject = false;
            this.chooseSubproject = false;

            if (this.postingStamp) {
                return;
            }

            this.postingStamp = true;

            console.log('projectID', project?.id);
            
            let stamp = {
                employee_id: parseInt(this.employee_id),
                project_id: parseInt(project?.id),
                device_id: parseInt(this.device_id),
                subproject_id: subproject?.id,
                entrance: this.entrance
            };


            console.log("Stamp", stamp);

            axios
                .post("/api/projectstamp", stamp)
                .then((resp) => {
                    console.log(resp.data);
                    this.chooseClient = 0;
                    this.chooseProject = 0;
                    this.chooseSubproject = 0;

                    if (resp.data.status == 'ended') {
                        this.welcome = 1;
                        setTimeout(this.displayIndex, 2000);
                        console.log("Ended");
                    }

                    if (resp.data.status == 'started') {
                        this.stamped = 1;
                        if (resp.data.project?.client?.name) {
                            this.clientName = resp.data.project?.client?.name;
                        }
                        setTimeout(this.displayIndex, 2000);
                    }
                    this.postingStamp = false;
                })
                .catch((error) => {
                    // console.log("Request: " + JSON.stringify(request));
                    console.log("Error: ", error);
                    // console.log("Error params: ", error.config.data);
                    // console.log("Error respText: ", error.request.responseText);
                    let data = JSON.parse(error.config.data);

                    if(!error.status || error.status == 404 || error.code == 'ERR_NETWORK'){
                        this.addStamp(data.employee_id, data.project_id, data.device_id, data.subproject_id);
                        this.displayInfo('Could not reach server. Saving data to device.');
                    }
                    else {
                        let error_message = JSON.parse(error.request.responseText);
                        this.displayError(error_message.message);
                    }
                    setTimeout(this.displayIndex, 2000);
                    this.postingStamp = false;
                });
        }
    }
}
</script>

<style lang="scss"></style>
